import { render, staticRenderFns } from "./AlmacenList.vue?vue&type=template&id=a64c90ea&scoped=true&"
import script from "./AlmacenList.vue?vue&type=script&lang=js&"
export * from "./AlmacenList.vue?vue&type=script&lang=js&"
import style0 from "./AlmacenList.vue?vue&type=style&index=0&id=a64c90ea&lang=scss&scoped=true&"
import style1 from "./AlmacenList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./AlmacenList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64c90ea",
  null
  
)

export default component.exports